module.exports = require("./es-SV.js");